module.exports = __webpack_public_path__ + "img/bookStar.58814207.svg";